var map = {
	"./adding-content.svg": [
		"11c0",
		"chunk-2d0aab43"
	],
	"./birth.svg": [
		"28c5",
		"chunk-2d0b39ee"
	],
	"./buing-links.svg": [
		"1913",
		"chunk-2d0ac340"
	],
	"./default.svg": [
		"e70d",
		"chunk-2d225f1c"
	],
	"./docs_demis.svg": [
		"41c1",
		"chunk-2d0c0861"
	],
	"./newsletter.svg": [
		"dd82",
		"chunk-2d229470"
	],
	"./post.svg": [
		"08d5",
		"chunk-2d0a514f"
	],
	"./press-relise.svg": [
		"1a6a",
		"chunk-2d0b5a31"
	],
	"./programmer-work.svg": [
		"0730",
		"chunk-2d0a479a"
	],
	"./quality_service.svg": [
		"f3c3",
		"chunk-2d22ca73"
	],
	"./report.svg": [
		"2cb1",
		"chunk-2d0bdb36"
	],
	"./setting-counters.svg": [
		"dc15",
		"chunk-2d228fd9"
	],
	"./usability.svg": [
		"0d6c",
		"chunk-2d0af117"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "b63d";
module.exports = webpackAsyncContext;